import type { FormFieldConfig } from '../components/common/FormField';

export const assetFieldConfig: {
  section: string;
  columns: number;
  column: number;
  fields: FormFieldConfig[];
}[] = [
  {
    section: 'Asset Details',
    columns: 1,
    column: 0,
    fields: [
      { field: 'asset_name', label: 'Asset Name', type: 'text' },
      { field: 'deal', label: 'Deal', type: 'autocomplete', optionsKey: 'deals', optionLabelKey: 'deal_name' },
      { field: 'address_1', label: 'Address 1', type: 'text' },
      { field: 'address_2', label: 'Address 2', type: 'text' },
      { field: 'city', label: 'City', type: 'text' },
      { field: 'postcode', label: 'Postcode', type: 'text' },
      { field: 'country', label: 'Country', type: 'select', optionsKey: 'countries', optionLabelKey: 'nicename' },
      { field: 'description', label: 'Description', type: 'multiline' },
    ],
  },
  {
    section: 'Valuation Info',
    columns: 1,
    column: 1,
    fields: [
      { field: 'currency', label: 'Currency', type: 'select', optionsKey: 'currencies',  isStringArray: true },
      { field: 'valuation_amount', label: 'Valuation Amount', type: 'number', formatNumber: true },
      { field: 'valuation_date', label: 'Valuation Date', type: 'date' },
      { field: 'acquisition_price', label: 'Acquisition Price', type: 'number', formatNumber: true },
      { field: 'acquisition_date', label: 'Acquisition Date', type: 'date' },
    ],
  },
  {
    section: 'Physical Attributes',
    columns: 1,
    column: 2,
    fields: [
      { field: 'sector', label: 'Sector', type: 'select', optionsKey: 'sectors', optionLabelKey: 'sector' },
      { field: 'title', label: 'Property Title', type: 'text' },
      { field: 'year_built', label: 'Year Built', type: 'number' },
      { field: 'year_refurbished', label: 'Year Refurbished', type: 'number' },
      { field: 'count_buildings', label: 'No. of Buildings', type: 'number' },
      { field: 'count_floors', label: 'No. of Floors', type: 'number' },
      { field: 'count_boxes', label: 'No. of Boxes', type: 'number' },
      { field: 'count_rooms', label: 'No. of Rooms', type: 'number' },
      { field: 'count_units', label: 'No. of Units', type: 'number' },
      { field: 'opex_annual', label: 'OPEX (Annual)', type: 'number', formatNumber: true },
      { field: 'epc_rating', label: 'EPC Rating', type: 'text' },
      { field: 'capex_total', label: 'Capex Total', type: 'number', formatNumber: true },
    ],
  },
  {
    section: 'Income',
    columns: 1,
    column: 3,
    fields: [
      { field: 'noi', label: 'NOI', type: 'number', formatNumber: true },
     
    ],
  },
];
